/**
 * Maps admin-configured ClientType names to India trademark filing logic.
 * Legacy code assumed names like "Other" and "Partnership Firm"; real catalogs vary.
 */

const STARTUP_CLIENT_TYPE_NAMES = new Set(['Other', 'Startup', 'StartUp']);

const SMALL_ENTERPRISE_STYLE_CLIENT_TYPE_NAMES = new Set([
  'Partnership Firm',
  'Partnership',
  'Limited Liability Partnership',
  'LLP',
  'Body Incorporate',
  'Private Limited',
  'Private Limited Company',
  'HUF',
  'Hindu Undivided Family',
  'Trust',
  'Society',
  'Propreitor',
  'Proprietor',
  'Sole Proprietorship'
]);

export function isStartupClientTypeName(name) {
  return !!name && STARTUP_CLIENT_TYPE_NAMES.has(name);
}

export function isSmallEnterpriseStyleClientTypeName(name) {
  return !!name && SMALL_ENTERPRISE_STYLE_CLIENT_TYPE_NAMES.has(name);
}
